import i18n from 'i18n';

export const MAX_TITLE_LENGTH = 70;
export const MAX_ARTICLE_LENGTH = 1000;

export const AllOption = {
  value: 'all',
  label: i18n.t('poll.create.form.placeholders.all'),
};
